import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch, clearAuthToken } from '../api/client';
import './OpsHome.css';

export default function OpsChangePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('New password and confirmation do not match.');
      return;
    }

    setSubmitting(true);
    try {
      await apiFetch('/ops/change-password', {
        method: 'POST',
        body: { currentPassword, newPassword, confirmPassword },
      });
      setMessage('Password updated successfully.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      const status = err?.status;
      if (status === 401 || status === 403) {
        clearAuthToken();
        navigate('/login', { replace: true });
        return;
      }
      setError(err?.data?.error || err?.message || 'Failed to update password');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="ops-shell">
      <main className="ops-main" style={{ maxWidth: 760, margin: '0 auto', width: '100%' }}>
        <header className="ops-header">
          <h1>Change Password</h1>
          <p>Update your internal ops portal password.</p>
        </header>

        <section className="ops-panel" style={{ marginTop: 24 }}>
          <form onSubmit={onSubmit} style={{ display: 'grid', gap: 14 }}>
            <label>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Current Password</div>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                style={inputStyle}
              />
            </label>

            <label>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>New Password</div>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={inputStyle}
              />
            </label>

            <label>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Confirm New Password</div>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={inputStyle}
              />
            </label>

            {error && <div className="ops-message error">{error}</div>}
            {message && <div className="ops-message">{message}</div>}

            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <button type="submit" disabled={submitting} className="ops-nav-item active">
                {submitting ? 'Updating…' : 'Update Password'}
              </button>
              <Link to="/ops" style={{ color: '#15606b', fontWeight: 700 }}>
                Back to Ops Home
              </Link>
            </div>
          </form>
        </section>
      </main>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  height: 44,
  border: '1px solid #cbe0dc',
  borderRadius: 10,
  padding: '0 12px',
  fontSize: 14,
  outline: 'none',
  boxSizing: 'border-box',
};
